// extracted by mini-css-extract-plugin
export default {"wrap":"Oq-z","searchHeaderWrap":"Pq-z","melodyCategory":"Qq-z","fullWidth":"Rq-z","items":"Sq-z","featureCss":"Tq-z","disabled":"Uq-z","imgCss":"Vq-z"};